import { Link } from 'react-router-dom'
import { Container } from '@/ui/design-system/Container'
import { Button } from '@/ui/components'
import { cn } from '@/shared/utils'

const PLANS = [
  {
    name: 'Free',
    price: '$0',
    cadence: 'forever',
    cta: 'Get started',
    bullets: [
      'Unlimited trips & vehicles',
      '8 crew per trip',
      'Meals, gear & itinerary',
      'GPX import',
      '1 GB photo storage',
    ],
    featured: false,
  },
  {
    name: 'Pro',
    price: '$4.99',
    cadence: '/mo · or $39.99/yr',
    cta: 'Start free trial',
    bullets: [
      'Everything in Free, unlimited crew',
      'Per-link sharing permissions',
      'Campsite finder + Ranger AI',
      'Campspotter weather & full 3D route tours',
      '5 GB photo storage',
    ],
    featured: true,
  },
]

export function PricingCompact() {
  return (
    <section className="bg-landing-surface py-20 lg:py-28">
      <Container size="content">
        <div className="mx-auto mb-10 max-w-xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">Simple pricing</h2>
          <p className="mt-3 text-base leading-relaxed text-white/60 sm:text-lg">
            Start free. Go Pro when the whole crew is in.
          </p>
        </div>

        <div className="mx-auto grid max-w-3xl gap-5 sm:grid-cols-2">
          {PLANS.map((plan) => (
            <div
              key={plan.name}
              className={cn(
                'relative flex flex-col rounded-2xl border p-6',
                plan.featured
                  ? 'border-landing-glow/50 bg-landing-raised shadow-glow-sm'
                  : 'border-landing-line bg-landing-raised',
              )}
            >
              {plan.featured && (
                <span className="absolute -top-3 right-5 rounded-full bg-landing-glow px-2.5 py-0.5 text-[11px] font-semibold text-landing-base">
                  Most popular
                </span>
              )}
              <p className="text-sm font-semibold uppercase tracking-[0.12em] text-white/60">{plan.name}</p>
              <p className="mt-2 flex items-baseline gap-1.5">
                <span className="text-4xl font-bold tracking-tight text-white">{plan.price}</span>
                <span className="text-sm text-white/50">{plan.cadence}</span>
              </p>
              <ul className="mt-5 flex-1 space-y-2.5">
                {plan.bullets.map((bullet) => (
                  <li key={bullet} className="flex items-start gap-2.5 text-sm text-white/75">
                    <span
                      className={cn('mt-[7px] h-1.5 w-1.5 shrink-0 rounded-full', plan.featured ? 'bg-landing-glow' : 'bg-white/30')}
                      aria-hidden
                    />
                    {bullet}
                  </li>
                ))}
              </ul>
              <Button
                asChild
                size="lg"
                variant={plan.featured ? 'default' : 'outline'}
                className={cn(
                  'mt-6 w-full',
                  plan.featured
                    ? 'shadow-glow-sm'
                    : 'border-white/25 bg-transparent text-white hover:bg-white/10 hover:text-white',
                )}
              >
                <a href="/signup">{plan.cta}</a>
              </Button>
            </div>
          ))}
        </div>

        <p className="mt-8 text-center">
          <Link
            to="/pricing"
            className="text-sm font-medium text-landing-glow-soft transition-colors hover:text-white"
          >
            Compare every feature
          </Link>
        </p>
      </Container>
    </section>
  )
}
